import { isArray, isNotEmpty, isObject } from "@churchofjesuschrist/maps-utils";
import GeoJsonType from "./GeoJsonType";
import GeometryType from "./GeometryType";
export const isGeoJson = obj => {
  if (isArray(obj)) {
    return obj.every(isGeoJson);
  }
  return isGeometry(obj) || isObject(obj) && obj.type && Object.values(GeoJsonType).includes(obj.type) && (obj.type === GeoJsonType.FEATURE && isNotEmpty(obj.geometry) || obj.type === GeoJsonType.FEATURE_COLLECTION && isArray(obj.features));
};
export const isGeometry = obj => {
  if (isArray(obj)) {
    return obj.every(isGeometry);
  }
  return isObject(obj) && obj.type && Object.values(GeometryType).includes(obj.type) && isArray(obj.coordinates);
};